import { RouteObject } from 'react-router'
import brandingRoutes from './branding/routes'
import featureManagementRoutes from './featureManagement/routes'
import languageAndTimeRoutes from './languageAndTime/routes'
import notificationRoutes from './notifications/routes'
import recognitionRoutes from './recognition/routes'
import valuesAndQualitiesRoutes from './valuesAndQualities/routes'

const routes: RouteObject[] = [
  ...languageAndTimeRoutes,
  ...notificationRoutes,
  ...brandingRoutes,
  ...valuesAndQualitiesRoutes,
  ...recognitionRoutes,
  ...featureManagementRoutes,
]

export default routes
